import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { resetOrderIndIdices } from "../orderIndUXSlice";
import { PageIndex } from "../../../models";
import { setOrderIndIndexThunk } from "../thunks/loadAllOrderInd";

export const useOrderIndIndex = () => {
  const pageIndex = useSelector<StoreType, PageIndex>(
    (s) => s.ux.trading.orderInd.index
  );

  const dispatch = useDispatch();
  const dispatchSetIndex = React.useCallback(
    (index: PageIndex) => dispatch(setOrderIndIndexThunk(index)),
    [dispatch]
  );
  const dispatchResetIndex = React.useCallback(
    () => dispatch(resetOrderIndIdices()),
    [dispatch]
  );

  return [pageIndex, dispatchSetIndex, dispatchResetIndex] as [
    typeof pageIndex,
    typeof dispatchSetIndex,
    typeof dispatchResetIndex
  ];
};
